import React from"react";
import { useNavigate } from"react-router-dom";

// 🔁 Mapping display names to backend route identifiers
const trackRoutes = {
"Java Backend Developer":"sgl_javabacked",
"Full Stack Web Developer (MERN)":"sgl_fullstack",
"Python Developer":"sgl_pythondeveloper",
"Frontend Developer":"sgl_frontenddeveloper",
"DevOps Engineer":"sgl_devops",
"QA / Automation Tester":"sgl_qa",
"Data Analyst":"sgl_dataanalyst",
"Mobile App Developer (Flutter)":"sgl_mobileapp",
"Cybersecurity Analyst":"sgl_cybersecurity",
"Cloud & SRE Engineer":"sgl_cloud",
"AI Engineer":"sgl_aienginner",
"Data Scientist":"sgl_datascientist",
"Blockchain Developer":"sgl_blockchain",
"Quantum Computing Learner":"sgl_quantumcomputing",
"Edge Computing Specialist":"sgl_edgecomputing",
"RPA & Automation Developer":"sgl_automation",
"GCP Cloud Engineer":"sgl_gcpcloud",
"Azure Cloud Associate":"sgl_azure",
"Big Data Engineer":"sgl_hadoop",
"Data Analytics Professional":"sgl_dataanalytics"
};

// 🔤 Use just the keys from the map for rendering
const tracks = Object.keys(trackRoutes);

const SkillgenLaunchpad = () => {
 const navigate = useNavigate();

 const handleClick = (trackLabel) => {
 const routeId = trackRoutes[trackLabel];
 if (routeId) {
 navigate(`/launchpad/${routeId}`);
 }
 };

 return (
 <div className="bg-bgMain min-h-screen text-white relative overflow-hidden font-sans">
 {/* Background decoration */}
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 {/* Header */}
 <div className="bg-gradient-to-r from-primary to-secondary text-white text-center py-10 text-4xl font-extrabold shadow-2xl relative z-10 uppercase tracking-tighter">
 SkillGen Launchpad 🚀
 </div>

 {/* Intro */}
 <div className="bg-bgSection py-16 px-6 text-center border-b border-accentGray/30 relative z-10">
 <h2 className="text-4xl md:text-5xl font-extrabold mb-6 bg-gradient-to-r from-primary via-secondary to-primary bg-clip-text text-transparent">Launch Your Tech Career</h2>
 <p className="text-xl text-muted max-w-3xl mx-auto leading-relaxed">
 Explore specialized skill tracks, master industry tools, and prepare for real-world excellence.
 </p>
 </div>

 {/* Tech Cards Grid */}
 <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
 <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
 {tracks.map((track, idx) => (
 <div
 key={idx}
 onClick={() => handleClick(track)}
 className="bg-bgMain border-2 border-primary/30 rounded-3xl p-8 text-center hover:bg-gradient-to-br hover:from-primary hover:to-secondary hover:border-transparent hover:shadow-[0_0_30px_rgba(79, 70, 229,0.3)] transition-all duration-300 cursor-pointer group hover:scale-[1.05]"
 >
 <h3 className="text-lg font-bold text-body group-hover:text-white group-hover:scale-110 transition-transform">{track}</h3>
 </div>
 ))}
 </div>
 </div>
 </div>
 );
};

export default SkillgenLaunchpad;




